import { useMemo } from 'react';
import { Toast } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { BsIcon } from 'src/ui/shared/components/icon/bs-icon.models';
import { sessionToastDelete } from '../../../../logic/features/sessions/session.actions';
import { ToastModel } from '../../../../models/session/toast.model';
import { Icon } from '../../../shared/components/icon/Icon';
import { useSessionText } from '../hooks/session.hook';

interface Props {
    toast: ToastModel;
}

export const ToastDisplay = ({ toast }: Props): React.ReactElement<any, any> | null => {
    const dispatch = useDispatch();

    const { variant, icon } = useMemo((): { icon: BsIcon; variant: string } => {
        switch (toast.variant) {
            case 'error':
                return {
                    variant: 'text-danger',
                    icon: 'exclamation-triangle',
                };
            case 'warning':
                return {
                    variant: 'text-warning',
                    icon: 'bell',
                };
            case 'success':
                return {
                    variant: 'text-success',
                    icon: 'hand-thumbs-up',
                };
        }
    }, [toast.variant]);

    const text = useSessionText(toast.type, toast.action);

    const onClose = () => {
        dispatch(sessionToastDelete({ id: toast.id }));
    };

    return (
        <Toast onClose={onClose} show={true} delay={4000} autohide={toast.autoHide}>
            <Toast.Header>
                <Icon iconClassName={`${variant} mr-2`} icon={icon} size="lg" />
                <span className="mr-2">{text}</span>
            </Toast.Header>
        </Toast>
    );
};
